var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.toast)?_c('div',{staticClass:"toast"},[_c('v-alert',{attrs:{"app":"","type":_vm.toast.type},scopedSlots:_vm._u([{key:"close",fn:function(){return [_c('v-icon',{staticClass:"ml-3",on:{"click":_vm.removeAlert}},[_vm._v("mdi-close")])]},proxy:true}],null,false,1465192771)},[_c('span',[_vm._v(_vm._s(_vm.toast.message))])])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }